export default function genererPrestation() {
  return {
    selected: false,
    reference: null,
    libelle: null,
    actif: true,
    typeEvenementSponsoringId: null,
    du: null,
    au: null,
    le: null,
    dateFin: null,
    dateTarif: null,
    prixUnitaire: null,
    categorieOperation: null,
    tauxTva: 20,
  };
}
